import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { rotationPreview } from "@/lib/scoutApi";

export const RotationPreview = ({ refreshKey }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    rotationPreview().then(setData).catch(() => setData({ rotations: [], featured_count: 0 }));
  }, [refreshKey]);

  if (!data) return null;

  return (
    <section data-testid="scout-rotation" className="border-t border-slate-200 pt-8">
      <div className="text-xs tracking-tight text-[var(--accent)] mb-2 flex items-center gap-2">
        <RefreshCw className="w-3.5 h-3.5" /> Rotation Preview · {data.featured_count} featured
      </div>
      {data.featured_count === 0 ? (
        <p data-testid="scout-rotation-empty" className="text-sm text-slate-500">
          Nobody is featured yet. Tick &ldquo;Feature in Voices We&apos;re Watching&rdquo; on a few cards
          (ideally one per pillar) and the Mon/Wed/Fri rotation appears here.
        </p>
      ) : (
        <div className="space-y-4">
          {data.rotations.map((r) => (
            <div key={r.date} data-testid={`scout-rotation-${r.date}`} className="text-sm">
              <div className="text-xs text-slate-500 mb-1">
                <span className="text-[#0A192F] font-medium">{r.label}</span> · {r.date}
              </div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-0.5">
                {r.voices.map((v) => (
                  <li key={v.id} className="flex gap-2 text-slate-700">
                    <span className="w-20 shrink-0 text-xs text-[var(--accent)] pt-0.5">{v.pillar}</span>
                    <span>{v.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default RotationPreview;
